import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
// import { notification } from 'antd'
import 'antd/dist/antd.css';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';
import { runInAction } from 'mobx';

export class RouterStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      routers: [],
      mapRouters: [],
      routerInMaps: [],
      routerList: [],
      routerInArea: [],
      selectRouter: [],
      tenantIds: null,
      offset: 0,
      limit: 15,
      search: null,
      sort: null,
      order: null,
      action: null,
      typeIds: [],
    });
  }

  async setAddRouter(datas, tenantIds) {
    let selectRouter = this.selectRouter;
    (datas || []).forEach((data) => {
      selectRouter.push(data.serial);
    });
    this.tenantIds = tenantIds;
    this.selectRouter = selectRouter;
    await this.getRouterForArea(
      selectRouter,
      this.offset,
      this.limit,
      this.search,
      this.sort,
      this.order,
      this.tenantIds,
    );
  }

  async setDeleteRouter(data, tenantIds) {
    let selectRouter = this.selectRouter;
    selectRouter = selectRouter.filter((serial) => serial !== data.serial);
    this.tenantIds = tenantIds;
    await this.getRouterForArea(
      selectRouter,
      this.offset,
      this.limit,
      this.search,
      this.sort,
      this.order,
      this.tenantIds,
    );
    this.selectRouter = selectRouter;
  }

  setAction(task, data) {
    this[task] = data;
  }

  resetData() {
    this.offset = 0;
    this.limit = 15;
    this.search = null;
    this.sort = null;
    this.order = null;
    this.tenantIds = null;
    this.routerList = [];
    this.routerInArea = [];
    this.selectRouter = [];
    this.typeIds = [];
  }

  setMapId(id) {
    let routers = this.routers;
    routers.map((val) => {
      val.mapId = val.id === id ? null : val.mapId;
      return val;
    });
    this.routers = routers;
  }

  async setData(task, data, getRouter = true) {
    this[task] = data;
    if (getRouter) {
      await this.getRouterList(this.offset, this.limit, this.search, this.sort, this.order, this.tenantIds);
    }
  }

  async setDataForArea(task, data, getArea = true) {
    this[task] = data;
    if (getArea) {
      await this.getRouterForArea(
        this.selectRouter,
        this.offset,
        this.limit,
        this.search,
        this.sort,
        this.order,
        this.tenantIds,
      );
    }
  }

  async getRouters() {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/router`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const routers = res.body || {};
        this.routers = routers;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getRouterList(offset = 0, limit = 15, search = null, sort = null, order = null, tenantIds = null) {
    this.loading = true;
    let queryOption = {};
    queryOption.offset = offset;
    queryOption.limit = limit;
    queryOption.typeIds = JSON.stringify(this.typeIds);
    if (tenantIds && tenantIds.length > 0) {
      queryOption.tenantIds = JSON.stringify(tenantIds);
    }
    if (search) {
      queryOption.search = search;
    }
    if (sort) {
      queryOption.sort = sort;
    }
    if (order) {
      queryOption.order = order;
    }
    try {
      let url = `${config.api.url}/${config.api.version}/router/cms`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const routerList = res.body || {};
        return (this.routerList = routerList);
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getRouterForArea(data, offset = 0, limit = 100, search = null, sort = null, order = null, tenantIds = null) {
    this.loading = true;
    let queryOption = {};
    queryOption.offset = offset;
    queryOption.limit = limit;
    if (tenantIds && tenantIds.length > 0) {
      queryOption.tenantIds = JSON.stringify(tenantIds);
    }
    if (search) {
      queryOption.search = search;
    }
    if (sort) {
      queryOption.sort = sort;
    }
    if (order) {
      queryOption.order = order;
    }
    const detail = {
      exceptRouter: data.length > 0 ? data : [],
    };
    try {
      let url = `${config.api.url}/${config.api.version}/router/area`;
      const res = await rp
        .post(url, {
          qs: queryOption,
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const routers = res.body || {};
        let list = {
          data: [],
          pagination: {},
        };
        list.data = (routers.data || []).map((val) => {
          return {
            id: val.id,
            serial: val.serial,
            label: val.place && val.place.length > 0 ? `${val.place} (${val.serial})` : `${val.name} (${val.serial})`,
          };
        });
        list.data = list.data.filter((item, pos) => {
          return true;
        });
        list.data.sort((a, b) => {
          const nameA = a.label.toUpperCase();
          const nameB = b.label.toUpperCase();
          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
        list.pagination = routers.pagination;
        this.routerInArea = list;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getRouterPlaces(routerIds) {
    this.loading = true;
    try {
      const data = { routerIds };
      let url = `${config.api.url}/${config.api.version}/router/place`;
      const res = await rp
        .post(url, {
          body: data,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const places = res.body || [];
        return places;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async clearRouterMap() {
    runInAction(() => {
      this.mapRouters = [];
      this.routerInMaps = [];
    });
  }

  async getRouterMap(mapId) {
    this.loading = true;
    try {
      const queryOption = {
        place: true,
        connection: true,
      };
      let url = `${config.api.url}/${config.api.version}/router/map/${mapId}`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const routers = res.body || [];
        this.mapRouters = routers;
        return routers;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getRouterInMaps(mapIds) {
    this.loading = true;
    try {
      const data = { mapIds: mapIds };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/router/map`, {
          body: data,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const routers = res.body || [];
        this.routerInMaps = routers;
        return routers;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        setTimeout(() => {
          clearLocalStorage();
          window.location.href = '/login';
        }, 1000);
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createRouter(data) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        place: data.placeName,
        tenantId: data.tenantId,
        serial: data.routerId,
        routerType: data.routerType,
        referenceNumber: data.referenceNumber,
        // manufacturer: data.manufacturer,
        description: data.description,
        version: data.version,
        useForLocalization: data.useForLocalization,
        outOfAreaDefault: data.outOfAreaDefault,
        purchasedDate: data.purchasedDate,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/router`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateRouter(data) {
    this.loading = true;
    try {
      const detail = {
        id: data.id,
        name: data.name,
        place: data.placeName,
        serial: data.routerId,
        tenantId: data.tenantId,
        routerType: data.routerType,
        referenceNumber: data.referenceNumber,
        // manufacturer: data.manufacturer,
        description: data.description,
        version: data.version,
        useForLocalization: data.useForLocalization,
        outOfAreaDefault: data.outOfAreaDefault,
        purchasedDate: data.purchasedDate,
      };
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/router/${data.id}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteMaps(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/router/unassign/map/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteRouter(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/router/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async findByMapId(id) {
    this.loading = true;
    try {
      const queryOption = {
        place: true,
      };
      let url = `${config.api.url}/${config.api.version}/router/map/${id}`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const routers = res.body || [];
        return routers;
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.loading = false;
    }
  }
}

export default new RouterStore();
